<template>
  <b-container fluid style="max-width:1200px;">
    <template v-if="!restrictedBrand">
      <!-- Header -->
      <ulu-service-header :refresh="refresh" :service="service" />
      <hr />
      <!-- Cards with details -->
      <ulu-service-details :refresh="refresh" :service="service" />
      <b-tabs style="margin-top: 1em; margin-bottom: 4em">
        <b-tab
          :title="$t('globals.data')"
          title-link-class="text-info"
        >
          <!-- Replace Case -->
          <ulu-service-replace
            v-if="service.service_type == 'replace' || service.service_type == 'separate_replace'"
            :refresh="refresh"
            :service="service"
          />
          <!-- Service Call Case -->
          <ulu-service-call
            v-if="service.service_type == 'service_call' || service.service_type == 'separate_service_call'"
            :refresh="refresh"
            :service="service"
          />
          <!-- Service Install Case -->
          <ulu-service-install
            v-if="service.service_type == 'install' || service.service_type == 'separate_install'"
            :refresh="refresh"
            :service="service"
          />

          <fieldtracker-service
            v-if="service.service_type == 'fieldtracker_service'"
            :refresh="refresh"
            :service="service" />
        </b-tab>
        <b-tab
          :title="$t('globals.history')"
          title-link-class="text-info"
        >
          <!-- History/Audits -->
          <ulu-service-history :audits="service.audits" />
        </b-tab>
      </b-tabs>
      <!-- Notes -->
      <ulu-service-notes
        :refresh="refresh"
        :service="service"
      />
    </template>
  </b-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import systemRestriction from "@/mixins/systemRestriction";

export default {
  mixins: [systemRestriction],
  systemRestrictionReload: "fetchService",
  components: {
    "ulu-service-header": () =>
      import("@/components/services/service/ServiceHeader"),
    "ulu-service-details": () =>
      import("@/components/services/service/ServiceDetails"),
    "ulu-service-replace": () =>
      import("@/components/services/service/cases/ServiceReplace"),
    "ulu-service-install": () =>
      import("@/components/services/service/cases/ServiceInstall"),
    "ulu-service-call": () =>
      import("@/components/services/service/cases/ServiceCall"),
    "fieldtracker-service": () =>
      import("@/components/services/service/cases/FieldtrackerService"),
    "ulu-service-notes": () =>
      import("@/components/services/service/ServiceNotes"),
    "ulu-service-history": () =>
      import("@/components/services/service/ServiceHistory")
  },
  data() {
    return {
      service: {
        id: 0,
        brand: "",
        status: "",
        order: { id: 0 },
        customer: { id: 0, company_name: "" },
        service_type: "",
        reason: "",
        reason_other: "",
        assembly_type: "",
        agent: { full_name: "" },
        created_at: "",
        billed: false,
        audits: [],
        notes: "",
        contact_info: "",
        warranty: false,
        service_devices: []
      }
    };
  },
  methods: {
    ...mapActions("axios_mod", ["simpleFetch"]),
    ...mapMutations(["setShowLoadingModal"]),
    refresh() {
      this.fetchService();
    },
    fetchService() {
      const data = {
        query: `
          query {
            service (id: ${parseInt(this.$route.params.id)}) {
              id
              order {
                id
                order_no
                devices {
                  id,
                  imei
                }
              }
              agent {
                full_name
              }
              customer {
                id
                company_name
              }
              warranty
              reason
              reason_other
              brand
              service_type
              assembly_type
              notes
              status
              created_at
              billed
              trello_card_url
              needs_to_be_billed
              fieldtracker_reference
              fieldtracker_task_name
              contact_info
              service_devices {
                id
                installation_id
                device_id
                imei
                license_plate
                status
                service_device_type
                fieldtracker_reference
                _showDetails
                audits {
                  agent {
                    full_name
                  }
                  action
                  created_at
                }
              }
              audits {
                agent {
                  full_name
                }
                action
                created_at
              }
            }
          }
        `
      };

      this.setShowLoadingModal(true);
      this.simpleFetch({data, this_ref: this}).then((res) => {
        if (res && this.checkSystem(res.service.brand)) {
          this.service = res.service;
        }
      }).finally(()=>{
        this.setShowLoadingModal(false)
      });
    }
  },
  computed: {
    ...mapGetters(["getUserBrandPermissions"])
  },
  created() {
    if (!this.getUserBrandPermissions.order_service_index) {
      this.$router.push({ name: "dashboard" });
    }
  },
  mounted() {
    this.fetchService();
  }
};
</script>
